import { render } from "./DeansReportsDialog.vue?vue&type=template&id=54faece3&scoped=true"
import script from "./DeansReportsDialog.vue?vue&type=script&lang=js"
export * from "./DeansReportsDialog.vue?vue&type=script&lang=js"

import "./DeansReportsDialog.vue?vue&type=style&index=0&id=54faece3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54faece3"]])

export default __exports__